import { gql } from '__generated__';

export default gql(`
  mutation SortTickets($input: SortTicketsInput!) {
    sortTickets(input: $input) {
      id
      tickets {
        id
      }
    }
  }
`);
